// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/imagen-de-fondo-12.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./svg/martillo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./svg/tick-circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./images/imagen-contacto-6.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #FFFFFF;
  margin: 0;
  margin-top: 3.8rem;
  padding: 0;
  overflow-x: hidden;
font-family: 'Lora', serif;
  color: #323437;
  scroll-behavior: smooth;
}

a {
  color: inherit;
  text-decoration: inherit;
}  

input,
textarea,
button,
select,
div,
a {
-webkit-tap-highlight-color: rgba(0,0,0,0);
} /* Remove blue highlight on Mobile*/

/**
* Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
 margin: 0;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/** SocialMedias **/

.social-medias {
  padding: 0.5rem;
  flex-direction: column;
  background-color: #323437;; 
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1); 
  border: none;
  align-items: center;
  position: fixed; 
  top: 6rem;
  left: 0;
  border-radius: 35px;
  z-index: 10;
}

.svg-en-social-media{
  width: 1.7rem;
  height: 1.7rem;
  cursor: pointer;
  filter: invert(70%);
}

.svg-en-social-media:hover{
  filter: invert(50%);
}

/** ScrollUp **/

.scroll-up {
  padding: 0.5rem;
  padding-left: 0.7rem;
  padding-right: 0.2rem;
  display: flex;
  background-color: #3a3c40;; 
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1); 
  border: none;
  position: fixed; 
  bottom: 2rem;
  right: 0.5rem;
  border-radius: 5px;
  z-index: 10;
  cursor: pointer;
}

.svg-en-scroll-up{
  width: 1.7rem;
  height: 1.7rem;
  cursor: pointer;
  filter: invert(100%);
}

.svg-en-scroll-up:hover{
  filter: invert(70%);
}

@media (max-width: 1000px) {
  .svg-en-scroll-up:hover{
    filter: invert(100%)
  }
}

/** TopBar **/
.topbar {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  display: flex;
  justify-content: space-between;
  color: #323437;
  background-color: #fff; 
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
  border-bottom: 1px solid #ddd;
  align-items: center;
  position: fixed; 
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

@media (max-width: 1000px) {
  .topbar{
    padding: 1rem 0.5rem ;
  }
}

.topbar-link{
  background-color: #fff;
  cursor: pointer;
  padding: 0.7rem;
  transition: background-color 0.3s ease;
}

.topbar-link:hover {
  background-color: #ecf0f1;
}

.logo-img{
  height: 2rem;
  width: 15rem;
  padding-top: 0.5rem;
  transition: transform 0.3s ease-in-out;
}

.logo-img:hover{
  transform: scale(1.05);
}

.triangulo-abajo {
  width: 0;
  height: 0;
  border-left: 0.4rem solid transparent; /* Ajusta el ancho del triángulo */
  border-right: 0.4rem solid transparent; /* Ajusta el ancho del triángulo */
  border-top: 0.4rem solid #323437; /* Ajusta el color y la altura del triángulo */
  display: flex;
  margin-left: 0.3rem;
}

.triangulo-derecha {
  width: 0;
  height: 0;
  border-top: 0.4rem solid transparent; /* Ajusta el ancho del triángulo */
  border-bottom: 0.4rem solid transparent; /* Ajusta el ancho del triángulo */
  border-left: 0.4rem solid #3498db; /* Ajusta el color y la altura del triángulo */
  display: inline-block; /* Para que el triángulo no afecte el diseño de los elementos vecinos */
  margin-left: 0.3rem;
}

.areas-menu-container{
display: flex;
flex-direction: column;
background-color: #fff; 
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
  border: 1px solid #ddd;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-left: 0.5rem;
  margin-top: 2.2rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: max-content;
}

.areas-menu-container li{
  background-color: #fff;
  color : #323437;
  padding: 0.2rem;
  cursor: pointer;
  transition: 0.3s ease;
  display: block;
}

.areas-menu-container li:hover{
  transform: translate(-1px, -1px);
  background-color: #ecf0f1;
}

.areas-menu-container li a {
  display: block;
  width: 100%;
  text-decoration: none;
}

.main-image-container{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 95vh;
  background-size: cover   ;
  background-repeat: no-repeat;
  background-position: center;
}

.main-image-left-cover{
  display: flex;
  width: 50%;
  background-color: #00000095;
  color: #fff;
  align-items: center;
  height: 95vh;
}

@media (max-width: 1000px) {
  .main-image-left-cover{
    width: 100%;
    text-align: center;
    background-color: #00000055
  }
}

.main-image-text{
  margin: 0 auto;
}

.main-image-en-rutas{
  width: 100%;
  height: 40vh;
  object-fit: cover;
  object-position: 0px 0px
}

@media (max-width: 1000px) {
.main-image-en-rutas{
  height: 20vh;
}
}

.boton-ppal-red-social{
  border-radius: 35px;
  text-align: center;
  padding: 0.5rem 1rem;
  font-size: 1.5rem;
  border: none;
  color: #fff;
  cursor: pointer;
  transition: 0.3s ease;
  width: 25rem;
  justify-content: center;
}

.boton-ppal-red-social.wapp{
  background-color:#25D366 ;
}

.boton-ppal-red-social.facebook{
  background-color:#0C4C85 ;
  
}


@media (max-width: 1000px) {
  .boton-ppal-red-social{
    margin-right: 0.2rem;
    margin-left: 0.2rem;
    padding: 0.25rem 0.5rem;
    font-size: 1.1rem;
    width: 18rem;
  }
}

.boton-ppal-red-social.wapp:hover{
  background-color: #128C7E;
}

.boton-ppal-red-social.facebook:hover{
  background-color: #1F69A3;
}

.wapp-svg-en-btn{
  height: 2.7rem;
  width: 2.7rem;
  margin-left: 0.75rem;
}

.facebook-svg-en-btn{
  height: 3rem;
  width: 3rem;
  margin-left: 0.75rem;
}

.font-titles{
  font-family: 'Playfair Display', serif;
}

.letter-spacing-0-1{
  letter-spacing: 0.1rem;
}

.titulo-ppal{
  font-size: 3rem;
  margin-top: 1rem;
  margin-bottom: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-family: 'Playfair Display', serif;
}

@media (max-width: 1000px) {
  .titulo-ppal{
    font-size: 2.6rem;
    padding-left: 0.5;
    padding-right: 0.5;
  }
}

.bg-light-blue{
background-color: #f0faff;
}

.grid-container{
  display: grid;
  row-gap: 50px;
  column-gap: 50px;
  grid-template-columns: auto auto auto;
  background-color: #F2F2F2;
  padding: 2rem;
  margin: 0rem 1rem;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);
}

@media (max-width: 1000px) {
  .grid-container{
    grid-template-columns: auto
  }
}


.grid-item {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.8);
  padding: 20px;
  font-size: 30px;
  text-align: center;
  box-shadow: 8px 8px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  border-radius: 4px;
}

.grid-item:hover{
  background-color: #ecf0f1;
  transform: translate(-3px, -3px) !important
}

.titulo-area-de-practica{
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: 400;
  font-family: 'Playfair Display', serif;
}

.ver-mas{
  position: absolute;
  display: flex;
  bottom: 1rem;
  right: 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  align-items: center;
  color: #3498db;
  letter-spacing: 0.03rem;
}

.imagen-area-ruta{
  width: 30rem;
  height: 20rem;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
}

.imagen-porque-elegirnos{
  height: 40rem;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
}

@media (max-width: 1000px) {
  .h-full-on-mobile {
    height: 100%
  }
}

.ul-style{
  list-style: none;
  margin-left: 2rem;
  padding: 0
}

.li-style{
  padding-left: 20px;
  position: relative;
}

.li-style::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center no-repeat;
  background-size: contain;
  width: 16px;
  height: 16px; 
  position: absolute;
  left: 0; 
  top: 50%;
  transform: translateY(-50%);
}

.li-style-elegirnos{
  padding-left: 2rem;
  position: relative;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}


.li-style-elegirnos::before{
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center no-repeat;
  background-size: contain;
  width: 20px;
  height: 20px; 
  position: absolute;
  left: 0; 
  top: 50%;
  transform: translateY(-50%);
  filter: invert(100%);
}

.svg-en-card{
  position: absolute;
  display: flex;
  bottom: 1rem;
  left: 1rem;
  width:1.5rem;
  height: 1.5rem;
  align-items: center;
}

.container-elegirnos{
  background-color: #001F3F;
  display: flex;
  padding-top: 8rem;
  padding-bottom: 5rem;
  color: #fff;
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (max-width: 1000px) {
  .container-elegirnos{
    flex-direction: column;
    justify-content: center;
    padding-top: 4rem;
    padding-left: 0rem;
  padding-right: 0rem;
  }
}

.ver-mas-grande-fondo-azul, .ver-mas-grande-fondo-blanco {
  display: inline-block;
  padding: 12px 22px;
  text-decoration: none;
  font-size: 20px;
  font-weight: bold;
  border-radius: 5px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.ver-mas-grande-fondo-azul{
  border: 2px solid transparent;
  color: #3498db;
}

.ver-mas-grande-fondo-blanco{
  border: 2px solid #3498db;
  background-color: #3498db;
  color: #fff
}

.ver-mas-grande-fondo-azul:hover{
  background-color: #3498db;
  color: #fff;
  transform: translateY(-3px); /* Desplazamiento hacia arriba */
}

.ver-mas-grande-fondo-blanco:hover{
  background-color: #fff;
  color: #3498db;
  transform: translateY(-3px); /* Desplazamiento hacia arriba */
}

/** Nuestro Equipo **/

.perfil-y-titulo{
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  align-items: center;
}

@media (min-width: 1000px) { 

  .perfil-y-titulo p{
    transition: transform 0.3s ease-in-out;
  }
  
  .imagen-perfil{
    transition: all 0.3s ease-in-out;
  }
  
  .perfil-y-titulo:hover p{
    transform: translateY(2rem) scale(1.2);
    font-weight: 600;
  }
  
  .perfil-y-titulo:hover .imagen-perfil{
    transform: scale(1.2);
  }
  
  .perfil-y-titulo:hover .ver-mas-grande-fondo-blanco{
    background-color: #fff;
    color: #3498db;
    transform: translateY(3rem) scale(1.2)
  }

    .perfil-y-titulo:hover .svg-en-enviar{
      filter: invert(77%) sepia(41%) saturate(7133%) hue-rotate(177deg) brightness(89%) contrast(93%);
    }

}



.contactanos-image-container{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  /* background-repeat: no-repeat; */
  background-position: center;
  color: #323437;
}

.contactanos-image-container-cover{
  /* opacity es el ultimo (0 para esta foto) */
  background-color: rgba(255, 255, 255, 0.4);
}

@media (max-width: 1000px) {
  .contactanos-image-container{
  background-size: contain;
  background-repeat: repeat;
  }
}

.contenedor-contacto{
    display: flex;
    flex-direction: column;
    width: 50%;
    background-color: #00000095;
    color: #fff;
    align-items: center;
    height: 100%;
    margin-left: 2rem;
    margin-right: 2rem;
    border-radius: 10px;
}

@media (max-width: 1000px) {
  .contenedor-contacto{
    width: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}

.google-maps-svg{
  width:5rem;
  height: 5rem;
  filter: drop-shadow(2px 4px 6px black);
  transition: all 0.3s ease-in-out;
}

.abrir-google{
  color: #3498db;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.3s ease-in-out;
}

.group-oficinas:hover .google-maps-svg {
  filter: drop-shadow(6px 12px 18px black);
}

.group-oficinas:hover .abrir-google {
  color: #fff;
}

.contenedor-contacto-derecha{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  align-items: center;
  margin-left: 2rem;
  margin-right: 2rem;
  align-self: stretch;
}

.flex-grow-1{
  flex-grow: 1;
}

@media (max-width: 1000px) {
  .contenedor-contacto-derecha{
    width: auto;
  margin-top: 2rem;
  }
}

.input-en-contacto{
    vertical-align: middle;
    text-align: left;
    box-sizing: border-box;
    padding: 0.5rem 1.5rem;
    padding-right: 3rem;
    margin: 0;
    outline: none;
    border: 1px solid rgba(0,0,0,.1);
    border-radius: 2rem;
    white-space: nowrap;
    font-weight: 400;
    font-size: 1rem;
    font-style: inherit;
    font-variant: inherit;
    font-family: inherit;
    text-decoration: none;
    resize: none;
    width: 100%;
}

.svg-en-contacto{
  position: absolute;
  display: flex;
  bottom: 0.3rem;
  right: 1rem;
  width:1.7rem;
  height: 1.7rem;
  align-items: center;

}

.svg-en-enviar{
  display: flex;
  width:1.7rem;
  height: 1.7rem;
  filter: invert(100%);
  transition: all 0.3s ease-in-out;
}

.svg-en-enviar.linkedin{
width : 12rem;
height: 3rem;
}

.group-button:hover .svg-en-enviar{
  filter: invert(77%) sepia(41%) saturate(7133%) hue-rotate(177deg) brightness(89%) contrast(93%);
}


.text-area-en-contacto{
  vertical-align: middle;
  text-align: left;
  box-sizing: border-box;
  padding: 1rem;
  width: 100%;
  height: 100%;
  margin: 0;
  outline: none;
  border: 1px solid rgba(0,0,0,.1);
  border-radius: 2rem;
  white-space: normal;
  font-weight: 400;
  font-size: 1rem;
  font-style: inherit;
  font-variant: inherit;
  font-family: inherit;
  text-decoration: none;
  overflow-x: hidden;
  resize: none;
}

/** Hamburger Menu **/
.menu-container {
  position: fixed;
  top: 0.75rem;
  right: 3.7rem;
  z-index: 110;
}

.z-150{
  z-index: 150;
}

.menu-icon {
  display: block;
  font-size: 24px;
  cursor: pointer;
  padding: 20px;
  position: fixed;
  z-index: 10;
}

.menu-icon .icon-bar {
  display: block;
  width: 20px;
  height: 2px;
  background-color: #323437;
  margin-bottom: 4px;
  transition: transform 0.3s ease-in-out;
}

.menu {
  padding-top: 5rem;
  position: fixed;
  top: 0;
  left: 100%;
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  transition: left 0.3s ease-in-out;
}

.menu ul {
  list-style: none;
  padding-right: 3rem;
  padding-left: 3rem;
  margin: 0;
}

.menu ul li {
  justify-content: center;
  padding-top : 0.5rem ;
  padding-bottom : 0.5rem ;
  border-bottom: 1px solid #323437;
}

.menu ul li a {
display: block;
width: 100%;
text-align: center;
text-decoration: none;
}

.li-on-page {
  opacity: 0.3;
}

.menu ul li a {
  text-decoration: none;
  font-size: 18px;
}

.input-checkbox-hamburger-menu {
  display: none;
}

input[type="checkbox"]:checked ~ .menu {
  left: 0;
}

input[type="checkbox"]:checked + .menu-icon .icon-bar:nth-child(1) {
  transform: rotate(45deg) translate(2px, 10px);
  background-color: #323437;
}

input[type="checkbox"]:checked + .menu-icon .icon-bar:nth-child(2) {
  opacity: 0;
}

input[type="checkbox"]:checked + .menu-icon .icon-bar:nth-child(3) {
  transform: rotate(-45deg) translate(-1px, -6px);
  background-color: #323437;
}

.menu-options{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.menu-areas{
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;;
}

.menu-areas-options{
  border-bottom: 0px solid #323437 !important;
  padding-top: 0.4rem !important;
  padding-bottom: 0.4rem !important;
}

.flecha-areas {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 11px solid #323437;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}

.flecha-areas.arriba {
  transform: rotate(180deg);
}

.w-fit-content-important{
  width: -moz-fit-content !important;
  width: fit-content !important;
}

/** Footer **/

.footer-container{
  background-color: #323437;
  color: #fff;
  border-top: 1px solid #fff;
  display: flex;
  justify-content: space-between;
  padding: 2rem;
  align-items: center;
}

@media (max-width: 1000px) {
  .footer-container{
    flex-direction: column;
    text-align: center;
  }
}

.svg-en-footer{
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
  cursor: pointer;
  filter: invert(70%);
}

.svg-en-footer:hover{
  filter: invert(50%);
}

/*Loading animation*/

.loading {
  font-size: 1.5rem;
}

.loading:after {
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
  animation: ellipsis steps(4, end) 900ms infinite;
  content: '\\2026'; /* ascii code for the ellipsis character */
  width: 0px;
}

@keyframes ellipsis {
  to {
    width: 1.25em;
  }
}

/** Modal **/

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 30px;
  cursor: pointer;
  font-size: 40px;
  /* width: 30px; 
  height: 30px; 
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #323437; 
  border-radius: 50%;
  padding-bottom: 0.1rem; */
}

.close-btn:hover{
opacity: 0.7;
}

.modal-content {
  padding: 5rem
}

@media (max-width: 1000px) {
  .modal-content{
    padding: 3rem 1rem
  }
}

.svg-modal{
  width: 4rem;
  height: 4rem;
}

.svg-back{
  height: 1.5rem;
  margin-right: 0.5rem;
}

@media (min-width: 1000px) {
  .svg-back:hover{
    filter: invert(50%);
  }
}

/** Utiles **/
.disabled {
  opacity: 0.5;
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}

.min-h-screen{
  min-height: 100vh;
}

.relative{
  position: relative;
}

.absolute{
  position: absolute;
}

.border-radius-10{
  border-radius: 10px;
}

.-mb-3{
  margin-bottom: -3rem;
}

.-mb-2{
  margin-bottom: -2rem;
}

.hidden {
  display: none;
}

.underline {
  text-decoration: underline;
}

.object-contain{
  object-fit: contain;
}

.object-cover{
  object-fit: cover;
}

.text-left {
    text-align: left;
  }
  
  .text-center {
    text-align: center;
  }
  
  .text-right {
    text-align: right;
  }

  .text-justify {
    text-align: justify;
  }

  .text-orange {
    color: #FF4E36;
  }

  .text-light-blue {
    color: #3498db;
  }

.text-2xs {
    font-size: 0.625rem;
  }
  
.text-xs {
    font-size: 0.75rem;
  }
  
.text-sm {
    font-size: 0.875rem;
  }
  
.text-base {
    font-size: 1rem;
  }
  
  .text-lg {
    font-size: 1.125rem;
  }
  
  .text-xl {
    font-size: 1.5rem;
  }
  
  .text-2xl {
    font-size: 2rem;
  }
  
  .text-3xl {
    font-size: 2.25rem;
  }
  
  .text-4xl {
    font-size: 3.5rem;
  }
  
  .italic {
    font-style: italic;
  }
  
  .not-italic {
    font-style: normal;
  }
  
  .uppercase {
    text-transform: uppercase;
  }
  
  .lowercase {
    text-transform: lowercase;
  }

  .justify-start {
    justify-content: flex-start;
  }
  
  .justify-end {
    justify-content: flex-end;
  }
  
  .justify-center {
    justify-content: center;
  }
  
  .justify-between {
    justify-content: space-between;
  }
  
  .justify-around {
    justify-content: space-around;
  }
  
  .justify-evenly {
    justify-content: space-evenly;
  }

  .items-center {
    align-items: center;
  }

  .pt-0 {
    padding-top: 0;
  }
  
  .pr-0 {
    padding-right: 0;
  }
  
  .pb-0 {
    padding-bottom: 0;
  }
  
  .pl-0 {
    padding-left: 0;
  }
  
  .pt-1 {
    padding-top: 1rem;
  }
  
  .pr-1 {
    padding-right: 1rem;
  }

  .pr-1-5 {
    padding-right: 1.5rem;
  }
  
  .pb-1 {
    padding-bottom: 1rem;
  }
  
  .pl-1 {
    padding-left: 1rem;
  }

  .pl-1-5 {
    padding-left: 1.5rem;
  }
  
  .pt-2 {
    padding-top: 2rem;
  }
  
  .pr-2 {
    padding-right: 2rem;
  }
  
  .pb-2 {
    padding-bottom: 2rem;
  }
  
  .pl-2 {
    padding-left: 2rem;
  }
  
  .pt-3 {
    padding-top: 3rem;
  }
  
  .pr-3 {
    padding-right: 3rem;
  }
  
  .pb-3 {
    padding-bottom: 3rem;
  }
  
  .pl-3 {
    padding-left: 3rem;
  }
  
  .pt-4 {
    padding-top: 4rem;
  }
  
  .pr-4 {
    padding-right: 4rem;
  }
  
  .pb-4 {
    padding-bottom: 4rem;
  }
  
  .pl-4 {
    padding-left: 4rem;
  }
  
  .pt-5 {
    padding-top: 5rem;
  }
  
  .pr-5 {
    padding-right: 5rem;
  }
  
  .pb-5 {
    padding-bottom: 5rem;
  }
  
  .pl-5 {
    padding-left: 5rem;
  }
  
  .pt-6 {
    padding-top: 6rem;
  }
  
  .pr-6 {
    padding-right: 6rem;
  }
  
  .pb-6 {
    padding-bottom: 6rem;
  }
  
  .pl-6 {
    padding-left: 6rem;
  }
  
  .pt-7 {
    padding-top: 7rem;
  }
  
  .pr-7 {
    padding-right: 7rem;
  }
  
  .pb-7 {
    padding-bottom: 7rem;
  }
  
  .pl-7 {
    padding-left: 7rem;
  }
  
  .pt-8 {
    padding-top: 8rem;
  }
  
  .pr-8 {
    padding-right: 8rem;
  }
  
  .pb-8 {
    padding-bottom: 8rem;
  }
  
  .pl-8 {
    padding-left: 8rem;
  }
  
  .pt-10 {
    padding-top: 10rem;
  }
  
  .pr-10 {
    padding-right: 10rem;
  }
  
  .pb-10 {
    padding-bottom: 10rem;
  }

  .p-0 {
    padding: 0;
  }
  
  .p-1 {
    padding: 1rem;
  }
  
  .p-2 {
    padding: 2rem;
  }
  
  .p-3 {
    padding: 3rem;
  }
  
  .p-4 {
    padding: 4rem;
  }

  .p-5 {
    padding: 5rem;
  }

  .py-0 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .py-0-125 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }
  
  .px-0 {
    padding-left: 0;
    padding-right: 0;
  }
  
  .py-1 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  
  .px-1 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  .py-2 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  
  .px-2 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  
  .py-3 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  
  .px-3 {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  
  .py-4 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  
  .px-4 {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  
  .py-5 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  
  .px-5 {
    padding-left: 5rem;
    padding-right: 5rem;
  }
  
  .py-6 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  
  .px-6 {
    padding-left: 6rem;
    padding-right: 6rem;
  }
  
  .py-7 {
    padding-top: 7rem;
    padding-bottom: 7rem;
  }
  
  .px-7 {
    padding-left: 7rem;
    padding-right: 7rem;
  }
  
  .py-8 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  
  .px-8 {
    padding-left: 8rem;
    padding-right: 8rem;
  }
  
  .py-10 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }
  
  .px-10 {
    padding-left: 10rem;
    padding-right: 10rem;
  }
  
  .py-11 {
    padding-top: 11rem;
    padding-bottom: 11rem;
  }
  
  .px-11 {
    padding-left: 11rem;
    padding-right: 11rem;
  }
  
  .py-12 {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }
  
  .px-12 {
    padding-left: 12rem;
    padding-right: 12rem;
  }
  
  .py-13 {
    padding-top: 13rem;
    padding-bottom: 13rem;
  }
  
  .px-13 {
    padding-left: 13rem;
    padding-right: 13rem;
  }
  
  .py-14 {
    padding-top: 14rem;
    padding-bottom: 14rem;
  }
  
  .px-14 {
    padding-left: 14rem;
    padding-right: 14rem;
  }
  
  .py-16 {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }
  
  .px-16 {
    padding-left: 16rem;
    padding-right: 16rem;
  }
  
  .py-18 {
    padding-top: 18rem;
    padding-bottom: 18rem;
  }
  
  .px-18 {
    padding-left: 18rem;
    padding-right: 18rem;
  }
  
  .py-19 {
    padding-top: 19rem;
    padding-bottom: 19rem;
  }
  
  .px-19 {
    padding-left: 19rem;
    padding-right: 19rem;
  }
  
  .py-20 {
    padding-top: 20rem;
    padding-bottom: 20rem;
  }
  
  .px-20 {
    padding-left: 20rem;
    padding-right: 20rem;
  }
  
  .py-26 {
    padding-top: 26rem;
    padding-bottom: 26rem;
  }
  
  .px-26 {
    padding-left: 26rem;
    padding-right: 26rem;
  }
  
  .py-34 {
    padding-top: 34rem;
    padding-bottom: 34rem;
  }
  
  .px-34 {
    padding-left: 34rem;
    padding-right: 34rem;
  }
  
  .py-38 {
    padding-top: 38rem;
    padding-bottom: 38rem;
  }
  
  .px-38 {
    padding-left: 38rem;
    padding-right: 38rem;
  }
  
  .py-40 {
    padding-top: 40rem;
    padding-bottom: 40rem;
  }
  
  .px-40 {
    padding-left: 40rem;
    padding-right: 40rem;
  }
  
  .py-48 {
    padding-top: 48rem;
    padding-bottom: 48rem;
  }
  
  .px-48 {
    padding-left: 48rem;
    padding-right: 48rem;
  }
  
  .py-56 {
    padding-top: 56rem;
    padding-bottom: 56rem;
  }
  
  .px-56 {
    padding-left: 56rem;
    padding-right: 56rem;
  }
  
  .py-62 {
    padding-top: 62rem;
    padding-bottom: 62rem;
  }
  
  .px-62 {
    padding-left: 62rem;
    padding-right: 62rem;
  }

.m-auto{
    margin: auto;
}

.my-0 {
  margin-top: 0;
  margin-bottom: 0;
}

.my-0-5 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}


.mx-0 {
  margin-left: 0;
  margin-right: 0;
}

.my-1 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.mx-1 {
  margin-left: 1rem;
  margin-right: 1rem;
}

.my-2 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.mx-2 {
  margin-left: 2rem;
  margin-right: 2rem;
}

.my-3 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.mx-3 {
  margin-left: 3rem;
  margin-right: 3rem;
}

.my-4 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}

.mx-4 {
  margin-left: 4rem;
  margin-right: 4rem;
}

.my-5 {
  margin-top: 5rem;
  margin-bottom: 5rem;
}

.mx-5 {
  margin-left: 5rem;
  margin-right: 5rem;
}

.-mt-0-5 {
  margin-top: -0.5rem;
}

.-mr-0-4 {
  margin-right: -0.4rem;
}


.m-0{
  margin: 0rem;
}

.m-0-5 {
    margin: 0.5rem;
}

.m-1 {
    margin: 1rem;
}

.m-2 {
    margin: 2rem;
}

.m-3 {
    margin: 3rem;
}

.m-4 {
    margin: 4rem;
}

.-mt-0-75 {
  margin-top: -0.75rem;
}

.mt-0 {
  margin-top: 0;
}

.mt-0-5 {
  margin-top: 0.5rem;
}

.mt-0-25 {
  margin-top: 0.25rem;
}

.mt-1 {
    margin-top: 1rem;
}

.mt-1-5 {
  margin-top: 1.5rem;
}

.mt-2 {
    margin-top: 2rem;
}

.mt-3 {
    margin-top: 3rem;
}

.mt-4 {
    margin-top: 4rem;
}

.mt-5 {
  margin-top: 5rem;
}

.mt-10 {
  margin-top: 10rem;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-0-125 {
  margin-bottom: 0.125rem;
}

.mb-0-25 {
  margin-bottom: 0.25rem;
}

.mb-0-5 {
  margin-bottom: 0.5rem;
}

.mb-0-75 {
  margin-bottom: 0.75rem;
}

.mb-1-5 {
  margin-bottom: 1.5rem;
}


.mb-1 {
    margin-bottom: 1rem;
}

.mb-2 {
    margin-bottom: 2rem;
}

.mb-3 {
    margin-bottom: 3rem;
}

.mb-4 {
    margin-bottom: 4rem;
}

.mb-5 {
  margin-bottom: 5rem;
}

.mb-7 {
  margin-bottom: 7rem;
}


.mr-0-5 {
  margin-right: 0.5rem;
}

.mr-1 {
    margin-right: 1rem;
}

.mr-1-5 {
  margin-right: 1.5rem;
}

.mr-2 {
    margin-right: 2rem;
}

.mr-3 {
    margin-right: 3rem;
}

.mr-4 {
    margin-right: 4rem;
}

.mr-5 {
  margin-right: 5rem;
}

.mr-12 {
  margin-right: 12rem;
}

.ml-0-25 {
  margin-left: 0.25rem;
}

.ml-0-5 {
  margin-left: 0.5rem;
}

.ml-1 {
    margin-left: 1rem;
}

.ml-2 {
    margin-left: 2rem;
}

.ml-3 {
    margin-left: 3rem;
}

.ml-4 {
    margin-left: 4rem;
}

.ml-5 {
  margin-left: 5rem;
}

.ml-12 {
  margin-left: 12rem;
}

.text-bold{
  font-weight: 700;
}

.flex{
    display: flex;
}

.flex-col{
    flex-direction: column;
}

.w-full{
    width: 100%;
}

.w-50{
  width: 50%;
}

.w-fit-content {
  width: -moz-fit-content;
  width: fit-content;
}

.max-w-none {
  max-width: none;
}

.max-w-2 {
  max-width: 2rem;
}

.max-w-5 {
  max-width: 5rem;
}

.max-w-8 {
  max-width: 8rem;
}

.max-w-10 {
  max-width: 10rem;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.w-0 {
  width: 0;
}

.w-1 {
  width: 1rem;
}

.w-2 {
  width: 2rem;
}

.w-3 {
  width: 3rem;
}

.w-4 {
  width: 4rem;
}

.w-5 {
  width: 5rem;
}

.w-6 {
  width: 6rem;
}

.w-7 {
  width: 7rem;
}

.w-8 {
  width: 8rem;
}

.w-10 {
  width: 10rem;
}

.h-full{
    height: 100%;
}

.h-fit-content {
  height: -moz-fit-content;
  height: fit-content;
}

.h-auo {
  height: auto;
}

.h-0 {
  height: 0;
}

.h-1 {
  height: 1rem;
}

.h-2 {
  height: 2rem;
}

.h-3 {
  height: 3rem;
}

.h-4 {
  height: 4rem;
}

.h-5 {
  height: 5rem;
}

.h-6 {
  height: 6rem;
}

.h-7 {
  height: 7rem;
}

.h-8 {
  height: 8rem;
}

.h-10 {
  height: 10rem;
}

.cursor-auto {
  cursor: auto;
}

.cursor-default {
  cursor: default;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-wait {
  cursor: wait;
}

.cursor-text {
  cursor: text;
}

.color-white{
  color: #fff;
}


/** Media Queries **/

@media (min-width: 1000px) {
  .sm\\:px-14 {
    padding-right: 14rem;
    padding-left: 14rem;
  }

  .sm\\:px-18 {
    padding-right: 18rem;
    padding-left: 18rem;
  }

  .sm\\:ml-4{
    margin-left: 4rem;
  }

  .sm\\:mt-4{
    margin-top: 4rem;
  }

  .sm\\:mb-1{
    margin-bottom: 1rem;
  }

  .sm\\:mb-0{
    margin-bottom: 0rem;
  }

  .sm\\:mr-0{
    margin-right: 0rem;
  }

  .sm\\:ml-0{
    margin-left: 0rem;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:table-cell {
    display: table-cell;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:flex-col {
      flex-direction: column;
  }

  .sm\\:flex-row {
    flex-direction: row;
}

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-start {
    justify-content: start;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-full {
    width: 100%;
  }


  .sm\\:ml-1 {
    margin-left: 1rem;
  }

  .sm\\:mt-0 {
    margin-top: 0rem;
  }

  .sm\\:object-contain{
object-fit: contain;
  }

  .sm\\:ml-12 {
    margin-left: 12rem;
  }

  .sm\\:mr-12 {
    margin-right: 12rem;
  }

  .sm\\:mr-4 {
    margin-right: 4rem;
  }

  .sm\\:w-50 {
    width: 50%;
}

.sm\\:h-40{
  height: 40%;
}

.sm\\:h-60{
  height: 60%;
}

.sm\\:px-6{
  padding-left: 6rem;
    padding-right: 6rem;
}

.sm\\:pt-3{
  padding-top: 3rem;
}

.sm\\:ml-2{
    margin-left: 2rem;
}

.sm\\:mb-0-5{
  margin-bottom: 0.5rem;
}

.sm\\:mb-1-5{
  margin-bottom: 1.5rem;
}

}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB,0BAA0B;EACxB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;;;;;AAMA,0CAA0C;AAC1C,EAAE,mCAAmC;;AAErC;;CAEC;;AAED;;;;;;;;;;;;;CAaC,SAAS;AACV;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,mBAAmB;;AAEnB;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,sCAAsC;EACtC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,OAAO;EACP,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;;AAEf;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE;EACF;AACF;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;EACtB,wCAAwC;EACxC,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,qCAAqC,EAAE,kCAAkC;EACzE,sCAAsC,EAAE,kCAAkC;EAC1E,gCAAgC,EAAE,8CAA8C;EAChF,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,oCAAoC,EAAE,kCAAkC;EACxE,uCAAuC,EAAE,kCAAkC;EAC3E,iCAAiC,EAAE,8CAA8C;EACjF,qBAAqB,EAAE,uEAAuE;EAC9F,mBAAmB;AACrB;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB,sBAAsB;EACpB,wCAAwC;EACxC,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yDAAwD;EACxD,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB;EACF;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;AACF;;AAEA;AACA;EACE,YAAY;AACd;AACA;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;;AAE3B;;;AAGA;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;AACA,yBAAyB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE;IACE;EACF;AACF;;;AAGA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oEAAsD;EACtD,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,WAAW;EACX,oEAAyD;EACzD,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;EACpB,mBAAmB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B,EAAE,gCAAgC;AAC/D;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,2BAA2B,EAAE,gCAAgC;AAC/D;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE;IACE,sCAAsC;EACxC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sCAAsC;IACtC,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,cAAc;IACd;EACF;;IAEE;MACE,+FAA+F;IACjG;;AAEJ;;;;AAIA;EACE,yDAAuD;EACvD,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE;EACA,wBAAwB;EACxB,yBAAyB;EACzB;AACF;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb,gBAAgB;EAChB;AACF;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;AACA,aAAa;AACb,YAAY;AACZ;;AAEA;EACE,+FAA+F;AACjG;;;AAGA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;AACA,cAAc;AACd,WAAW;AACX,kBAAkB;AAClB,qBAAqB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAA6B;EAA7B,6BAA6B;AAC/B;;AAEA,aAAa;;AAEb;EACE,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;;AAEpB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EAEtB,gDAAgD;EAChD,gBAAgB,EAAE,0CAA0C;EAC5D,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAQA,YAAY;;AAEZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf;;;;;;;2BAOyB;AAC3B;;AAEA;AACA,YAAY;AACZ;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;AAEF;IACI,mBAAmB;EACrB;;AAEF;IACI,kBAAkB;EACpB;;AAEF;IACI,mBAAmB;EACrB;;AAEF;IACI,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;AAEF;IACI,YAAY;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,YAAY;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;;AAGA,oBAAoB;;AAEpB;EACE;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;IACE,mBAAmB;AACvB;;EAEE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;AACF,mBAAmB;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;IAChB,mBAAmB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA","sourcesContent":["body {\n  background-color: #FFFFFF;\n  margin: 0;\n  margin-top: 3.8rem;\n  padding: 0;\n  overflow-x: hidden;\nfont-family: 'Lora', serif;\n  color: #323437;\n  scroll-behavior: smooth;\n}\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}  \n\ninput,\ntextarea,\nbutton,\nselect,\ndiv,\na {\n-webkit-tap-highlight-color: rgba(0,0,0,0);\n} /* Remove blue highlight on Mobile*/\n\n/**\n* Removes the default spacing and border for appropriate elements.\n*/\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n margin: 0;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n/** SocialMedias **/\n\n.social-medias {\n  padding: 0.5rem;\n  flex-direction: column;\n  background-color: #323437;; \n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1); \n  border: none;\n  align-items: center;\n  position: fixed; \n  top: 6rem;\n  left: 0;\n  border-radius: 35px;\n  z-index: 10;\n}\n\n.svg-en-social-media{\n  width: 1.7rem;\n  height: 1.7rem;\n  cursor: pointer;\n  filter: invert(70%);\n}\n\n.svg-en-social-media:hover{\n  filter: invert(50%);\n}\n\n/** ScrollUp **/\n\n.scroll-up {\n  padding: 0.5rem;\n  padding-left: 0.7rem;\n  padding-right: 0.2rem;\n  display: flex;\n  background-color: #3a3c40;; \n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1); \n  border: none;\n  position: fixed; \n  bottom: 2rem;\n  right: 0.5rem;\n  border-radius: 5px;\n  z-index: 10;\n  cursor: pointer;\n}\n\n.svg-en-scroll-up{\n  width: 1.7rem;\n  height: 1.7rem;\n  cursor: pointer;\n  filter: invert(100%);\n}\n\n.svg-en-scroll-up:hover{\n  filter: invert(70%);\n}\n\n@media (max-width: 1000px) {\n  .svg-en-scroll-up:hover{\n    filter: invert(100%)\n  }\n}\n\n/** TopBar **/\n.topbar {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  display: flex;\n  justify-content: space-between;\n  color: #323437;\n  background-color: #fff; \n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); \n  border-bottom: 1px solid #ddd;\n  align-items: center;\n  position: fixed; \n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n}\n\n@media (max-width: 1000px) {\n  .topbar{\n    padding: 1rem 0.5rem ;\n  }\n}\n\n.topbar-link{\n  background-color: #fff;\n  cursor: pointer;\n  padding: 0.7rem;\n  transition: background-color 0.3s ease;\n}\n\n.topbar-link:hover {\n  background-color: #ecf0f1;\n}\n\n.logo-img{\n  height: 2rem;\n  width: 15rem;\n  padding-top: 0.5rem;\n  transition: transform 0.3s ease-in-out;\n}\n\n.logo-img:hover{\n  transform: scale(1.05);\n}\n\n.triangulo-abajo {\n  width: 0;\n  height: 0;\n  border-left: 0.4rem solid transparent; /* Ajusta el ancho del triángulo */\n  border-right: 0.4rem solid transparent; /* Ajusta el ancho del triángulo */\n  border-top: 0.4rem solid #323437; /* Ajusta el color y la altura del triángulo */\n  display: flex;\n  margin-left: 0.3rem;\n}\n\n.triangulo-derecha {\n  width: 0;\n  height: 0;\n  border-top: 0.4rem solid transparent; /* Ajusta el ancho del triángulo */\n  border-bottom: 0.4rem solid transparent; /* Ajusta el ancho del triángulo */\n  border-left: 0.4rem solid #3498db; /* Ajusta el color y la altura del triángulo */\n  display: inline-block; /* Para que el triángulo no afecte el diseño de los elementos vecinos */\n  margin-left: 0.3rem;\n}\n\n.areas-menu-container{\ndisplay: flex;\nflex-direction: column;\nbackground-color: #fff; \n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); \n  border: 1px solid #ddd;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  margin-left: 0.5rem;\n  margin-top: 2.2rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: max-content;\n}\n\n.areas-menu-container li{\n  background-color: #fff;\n  color : #323437;\n  padding: 0.2rem;\n  cursor: pointer;\n  transition: 0.3s ease;\n  display: block;\n}\n\n.areas-menu-container li:hover{\n  transform: translate(-1px, -1px);\n  background-color: #ecf0f1;\n}\n\n.areas-menu-container li a {\n  display: block;\n  width: 100%;\n  text-decoration: none;\n}\n\n.main-image-container{\n  background-image: url('./images/imagen-de-fondo-12.jpg');\n  height: 95vh;\n  background-size: cover   ;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.main-image-left-cover{\n  display: flex;\n  width: 50%;\n  background-color: #00000095;\n  color: #fff;\n  align-items: center;\n  height: 95vh;\n}\n\n@media (max-width: 1000px) {\n  .main-image-left-cover{\n    width: 100%;\n    text-align: center;\n    background-color: #00000055\n  }\n}\n\n.main-image-text{\n  margin: 0 auto;\n}\n\n.main-image-en-rutas{\n  width: 100%;\n  height: 40vh;\n  object-fit: cover;\n  object-position: 0px 0px\n}\n\n@media (max-width: 1000px) {\n.main-image-en-rutas{\n  height: 20vh;\n}\n}\n\n.boton-ppal-red-social{\n  border-radius: 35px;\n  text-align: center;\n  padding: 0.5rem 1rem;\n  font-size: 1.5rem;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  transition: 0.3s ease;\n  width: 25rem;\n  justify-content: center;\n}\n\n.boton-ppal-red-social.wapp{\n  background-color:#25D366 ;\n}\n\n.boton-ppal-red-social.facebook{\n  background-color:#0C4C85 ;\n  \n}\n\n\n@media (max-width: 1000px) {\n  .boton-ppal-red-social{\n    margin-right: 0.2rem;\n    margin-left: 0.2rem;\n    padding: 0.25rem 0.5rem;\n    font-size: 1.1rem;\n    width: 18rem;\n  }\n}\n\n.boton-ppal-red-social.wapp:hover{\n  background-color: #128C7E;\n}\n\n.boton-ppal-red-social.facebook:hover{\n  background-color: #1F69A3;\n}\n\n.wapp-svg-en-btn{\n  height: 2.7rem;\n  width: 2.7rem;\n  margin-left: 0.75rem;\n}\n\n.facebook-svg-en-btn{\n  height: 3rem;\n  width: 3rem;\n  margin-left: 0.75rem;\n}\n\n.font-titles{\n  font-family: 'Playfair Display', serif;\n}\n\n.letter-spacing-0-1{\n  letter-spacing: 0.1rem;\n}\n\n.titulo-ppal{\n  font-size: 3rem;\n  margin-top: 1rem;\n  margin-bottom: 2rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  font-family: 'Playfair Display', serif;\n}\n\n@media (max-width: 1000px) {\n  .titulo-ppal{\n    font-size: 2.6rem;\n    padding-left: 0.5;\n    padding-right: 0.5;\n  }\n}\n\n.bg-light-blue{\nbackground-color: #f0faff;\n}\n\n.grid-container{\n  display: grid;\n  row-gap: 50px;\n  column-gap: 50px;\n  grid-template-columns: auto auto auto;\n  background-color: #F2F2F2;\n  padding: 2rem;\n  margin: 0rem 1rem;\n  box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);\n}\n\n@media (max-width: 1000px) {\n  .grid-container{\n    grid-template-columns: auto\n  }\n}\n\n\n.grid-item {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.8);\n  padding: 20px;\n  font-size: 30px;\n  text-align: center;\n  box-shadow: 8px 8px 3px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n  border-radius: 4px;\n}\n\n.grid-item:hover{\n  background-color: #ecf0f1;\n  transform: translate(-3px, -3px) !important\n}\n\n.titulo-area-de-practica{\n  margin-bottom: 1rem;\n  font-size: 2rem;\n  font-weight: 400;\n  font-family: 'Playfair Display', serif;\n}\n\n.ver-mas{\n  position: absolute;\n  display: flex;\n  bottom: 1rem;\n  right: 1rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  align-items: center;\n  color: #3498db;\n  letter-spacing: 0.03rem;\n}\n\n.imagen-area-ruta{\n  width: 30rem;\n  height: 20rem;\n  object-fit: cover;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid #ddd;\n}\n\n.imagen-porque-elegirnos{\n  height: 40rem;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid #ddd;\n}\n\n@media (max-width: 1000px) {\n  .h-full-on-mobile {\n    height: 100%\n  }\n}\n\n.ul-style{\n  list-style: none;\n  margin-left: 2rem;\n  padding: 0\n}\n\n.li-style{\n  padding-left: 20px;\n  position: relative;\n}\n\n.li-style::before {\n  content: \"\";\n  background: url('./svg/martillo.svg') center no-repeat;\n  background-size: contain;\n  width: 16px;\n  height: 16px; \n  position: absolute;\n  left: 0; \n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.li-style-elegirnos{\n  padding-left: 2rem;\n  position: relative;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n}\n\n\n.li-style-elegirnos::before{\n  content: \"\";\n  background: url('./svg/tick-circle.svg') center no-repeat;\n  background-size: contain;\n  width: 20px;\n  height: 20px; \n  position: absolute;\n  left: 0; \n  top: 50%;\n  transform: translateY(-50%);\n  filter: invert(100%);\n}\n\n.svg-en-card{\n  position: absolute;\n  display: flex;\n  bottom: 1rem;\n  left: 1rem;\n  width:1.5rem;\n  height: 1.5rem;\n  align-items: center;\n}\n\n.container-elegirnos{\n  background-color: #001F3F;\n  display: flex;\n  padding-top: 8rem;\n  padding-bottom: 5rem;\n  color: #fff;\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n@media (max-width: 1000px) {\n  .container-elegirnos{\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 4rem;\n    padding-left: 0rem;\n  padding-right: 0rem;\n  }\n}\n\n.ver-mas-grande-fondo-azul, .ver-mas-grande-fondo-blanco {\n  display: inline-block;\n  padding: 12px 22px;\n  text-decoration: none;\n  font-size: 20px;\n  font-weight: bold;\n  border-radius: 5px;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n}\n\n.ver-mas-grande-fondo-azul{\n  border: 2px solid transparent;\n  color: #3498db;\n}\n\n.ver-mas-grande-fondo-blanco{\n  border: 2px solid #3498db;\n  background-color: #3498db;\n  color: #fff\n}\n\n.ver-mas-grande-fondo-azul:hover{\n  background-color: #3498db;\n  color: #fff;\n  transform: translateY(-3px); /* Desplazamiento hacia arriba */\n}\n\n.ver-mas-grande-fondo-blanco:hover{\n  background-color: #fff;\n  color: #3498db;\n  transform: translateY(-3px); /* Desplazamiento hacia arriba */\n}\n\n/** Nuestro Equipo **/\n\n.perfil-y-titulo{\n  display: flex;\n  flex-direction: column;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n  align-items: center;\n}\n\n@media (min-width: 1000px) { \n\n  .perfil-y-titulo p{\n    transition: transform 0.3s ease-in-out;\n  }\n  \n  .imagen-perfil{\n    transition: all 0.3s ease-in-out;\n  }\n  \n  .perfil-y-titulo:hover p{\n    transform: translateY(2rem) scale(1.2);\n    font-weight: 600;\n  }\n  \n  .perfil-y-titulo:hover .imagen-perfil{\n    transform: scale(1.2);\n  }\n  \n  .perfil-y-titulo:hover .ver-mas-grande-fondo-blanco{\n    background-color: #fff;\n    color: #3498db;\n    transform: translateY(3rem) scale(1.2)\n  }\n\n    .perfil-y-titulo:hover .svg-en-enviar{\n      filter: invert(77%) sepia(41%) saturate(7133%) hue-rotate(177deg) brightness(89%) contrast(93%);\n    }\n\n}\n\n\n\n.contactanos-image-container{\n  background-image: url('./images/imagen-contacto-6.jpg');\n  background-size: cover;\n  /* background-repeat: no-repeat; */\n  background-position: center;\n  color: #323437;\n}\n\n.contactanos-image-container-cover{\n  /* opacity es el ultimo (0 para esta foto) */\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n@media (max-width: 1000px) {\n  .contactanos-image-container{\n  background-size: contain;\n  background-repeat: repeat;\n  }\n}\n\n.contenedor-contacto{\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    background-color: #00000095;\n    color: #fff;\n    align-items: center;\n    height: 100%;\n    margin-left: 2rem;\n    margin-right: 2rem;\n    border-radius: 10px;\n}\n\n@media (max-width: 1000px) {\n  .contenedor-contacto{\n    width: auto;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n}\n\n.google-maps-svg{\n  width:5rem;\n  height: 5rem;\n  filter: drop-shadow(2px 4px 6px black);\n  transition: all 0.3s ease-in-out;\n}\n\n.abrir-google{\n  color: #3498db;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  transition: all 0.3s ease-in-out;\n}\n\n.group-oficinas:hover .google-maps-svg {\n  filter: drop-shadow(6px 12px 18px black);\n}\n\n.group-oficinas:hover .abrir-google {\n  color: #fff;\n}\n\n.contenedor-contacto-derecha{\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 50%;\n  align-items: center;\n  margin-left: 2rem;\n  margin-right: 2rem;\n  align-self: stretch;\n}\n\n.flex-grow-1{\n  flex-grow: 1;\n}\n\n@media (max-width: 1000px) {\n  .contenedor-contacto-derecha{\n    width: auto;\n  margin-top: 2rem;\n  }\n}\n\n.input-en-contacto{\n    vertical-align: middle;\n    text-align: left;\n    box-sizing: border-box;\n    padding: 0.5rem 1.5rem;\n    padding-right: 3rem;\n    margin: 0;\n    outline: none;\n    border: 1px solid rgba(0,0,0,.1);\n    border-radius: 2rem;\n    white-space: nowrap;\n    font-weight: 400;\n    font-size: 1rem;\n    font-style: inherit;\n    font-variant: inherit;\n    font-family: inherit;\n    text-decoration: none;\n    resize: none;\n    width: 100%;\n}\n\n.svg-en-contacto{\n  position: absolute;\n  display: flex;\n  bottom: 0.3rem;\n  right: 1rem;\n  width:1.7rem;\n  height: 1.7rem;\n  align-items: center;\n\n}\n\n.svg-en-enviar{\n  display: flex;\n  width:1.7rem;\n  height: 1.7rem;\n  filter: invert(100%);\n  transition: all 0.3s ease-in-out;\n}\n\n.svg-en-enviar.linkedin{\nwidth : 12rem;\nheight: 3rem;\n}\n\n.group-button:hover .svg-en-enviar{\n  filter: invert(77%) sepia(41%) saturate(7133%) hue-rotate(177deg) brightness(89%) contrast(93%);\n}\n\n\n.text-area-en-contacto{\n  vertical-align: middle;\n  text-align: left;\n  box-sizing: border-box;\n  padding: 1rem;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  outline: none;\n  border: 1px solid rgba(0,0,0,.1);\n  border-radius: 2rem;\n  white-space: normal;\n  font-weight: 400;\n  font-size: 1rem;\n  font-style: inherit;\n  font-variant: inherit;\n  font-family: inherit;\n  text-decoration: none;\n  overflow-x: hidden;\n  resize: none;\n}\n\n/** Hamburger Menu **/\n.menu-container {\n  position: fixed;\n  top: 0.75rem;\n  right: 3.7rem;\n  z-index: 110;\n}\n\n.z-150{\n  z-index: 150;\n}\n\n.menu-icon {\n  display: block;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 20px;\n  position: fixed;\n  z-index: 10;\n}\n\n.menu-icon .icon-bar {\n  display: block;\n  width: 20px;\n  height: 2px;\n  background-color: #323437;\n  margin-bottom: 4px;\n  transition: transform 0.3s ease-in-out;\n}\n\n.menu {\n  padding-top: 5rem;\n  position: fixed;\n  top: 0;\n  left: 100%;\n  width: 100%;\n  height: 100%;\n  background-color: #FFFFFF;\n  transition: left 0.3s ease-in-out;\n}\n\n.menu ul {\n  list-style: none;\n  padding-right: 3rem;\n  padding-left: 3rem;\n  margin: 0;\n}\n\n.menu ul li {\n  justify-content: center;\n  padding-top : 0.5rem ;\n  padding-bottom : 0.5rem ;\n  border-bottom: 1px solid #323437;\n}\n\n.menu ul li a {\ndisplay: block;\nwidth: 100%;\ntext-align: center;\ntext-decoration: none;\n}\n\n.li-on-page {\n  opacity: 0.3;\n}\n\n.menu ul li a {\n  text-decoration: none;\n  font-size: 18px;\n}\n\n.input-checkbox-hamburger-menu {\n  display: none;\n}\n\ninput[type=\"checkbox\"]:checked ~ .menu {\n  left: 0;\n}\n\ninput[type=\"checkbox\"]:checked + .menu-icon .icon-bar:nth-child(1) {\n  transform: rotate(45deg) translate(2px, 10px);\n  background-color: #323437;\n}\n\ninput[type=\"checkbox\"]:checked + .menu-icon .icon-bar:nth-child(2) {\n  opacity: 0;\n}\n\ninput[type=\"checkbox\"]:checked + .menu-icon .icon-bar:nth-child(3) {\n  transform: rotate(-45deg) translate(-1px, -6px);\n  background-color: #323437;\n}\n\n.menu-options{\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.menu-areas{\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;;\n}\n\n.menu-areas-options{\n  border-bottom: 0px solid #323437 !important;\n  padding-top: 0.4rem !important;\n  padding-bottom: 0.4rem !important;\n}\n\n.flecha-areas {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 11px solid #323437;\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n}\n\n.flecha-areas.arriba {\n  transform: rotate(180deg);\n}\n\n.w-fit-content-important{\n  width: fit-content !important;\n}\n\n/** Footer **/\n\n.footer-container{\n  background-color: #323437;\n  color: #fff;\n  border-top: 1px solid #fff;\n  display: flex;\n  justify-content: space-between;\n  padding: 2rem;\n  align-items: center;\n}\n\n@media (max-width: 1000px) {\n  .footer-container{\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\n.svg-en-footer{\n  width: 2rem;\n  height: 2rem;\n  margin-right: 0.5rem;\n  cursor: pointer;\n  filter: invert(70%);\n}\n\n.svg-en-footer:hover{\n  filter: invert(50%);\n}\n\n/*Loading animation*/\n\n.loading {\n  font-size: 1.5rem;\n}\n\n.loading:after {\n  overflow: hidden;\n  display: inline-block;\n  vertical-align: bottom;\n  -webkit-animation: ellipsis steps(4, end) 900ms infinite;\n  animation: ellipsis steps(4, end) 900ms infinite;\n  content: '\\2026'; /* ascii code for the ellipsis character */\n  width: 0px;\n}\n\n@keyframes ellipsis {\n  to {\n    width: 1.25em;\n  }\n}\n\n@-webkit-keyframes ellipsis {\n  to {\n    width: 1.25em;\n  }\n}\n\n/** Modal **/\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.modal {\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  position: relative;\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 30px;\n  cursor: pointer;\n  font-size: 40px;\n  /* width: 30px; \n  height: 30px; \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid #323437; \n  border-radius: 50%;\n  padding-bottom: 0.1rem; */\n}\n\n.close-btn:hover{\nopacity: 0.7;\n}\n\n.modal-content {\n  padding: 5rem\n}\n\n@media (max-width: 1000px) {\n  .modal-content{\n    padding: 3rem 1rem\n  }\n}\n\n.svg-modal{\n  width: 4rem;\n  height: 4rem;\n}\n\n.svg-back{\n  height: 1.5rem;\n  margin-right: 0.5rem;\n}\n\n@media (min-width: 1000px) {\n  .svg-back:hover{\n    filter: invert(50%);\n  }\n}\n\n/** Utiles **/\n.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.min-h-screen{\n  min-height: 100vh;\n}\n\n.relative{\n  position: relative;\n}\n\n.absolute{\n  position: absolute;\n}\n\n.border-radius-10{\n  border-radius: 10px;\n}\n\n.-mb-3{\n  margin-bottom: -3rem;\n}\n\n.-mb-2{\n  margin-bottom: -2rem;\n}\n\n.hidden {\n  display: none;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.object-contain{\n  object-fit: contain;\n}\n\n.object-cover{\n  object-fit: cover;\n}\n\n.text-left {\n    text-align: left;\n  }\n  \n  .text-center {\n    text-align: center;\n  }\n  \n  .text-right {\n    text-align: right;\n  }\n\n  .text-justify {\n    text-align: justify;\n  }\n\n  .text-orange {\n    color: #FF4E36;\n  }\n\n  .text-light-blue {\n    color: #3498db;\n  }\n\n.text-2xs {\n    font-size: 0.625rem;\n  }\n  \n.text-xs {\n    font-size: 0.75rem;\n  }\n  \n.text-sm {\n    font-size: 0.875rem;\n  }\n  \n.text-base {\n    font-size: 1rem;\n  }\n  \n  .text-lg {\n    font-size: 1.125rem;\n  }\n  \n  .text-xl {\n    font-size: 1.5rem;\n  }\n  \n  .text-2xl {\n    font-size: 2rem;\n  }\n  \n  .text-3xl {\n    font-size: 2.25rem;\n  }\n  \n  .text-4xl {\n    font-size: 3.5rem;\n  }\n  \n  .italic {\n    font-style: italic;\n  }\n  \n  .not-italic {\n    font-style: normal;\n  }\n  \n  .uppercase {\n    text-transform: uppercase;\n  }\n  \n  .lowercase {\n    text-transform: lowercase;\n  }\n\n  .justify-start {\n    justify-content: flex-start;\n  }\n  \n  .justify-end {\n    justify-content: flex-end;\n  }\n  \n  .justify-center {\n    justify-content: center;\n  }\n  \n  .justify-between {\n    justify-content: space-between;\n  }\n  \n  .justify-around {\n    justify-content: space-around;\n  }\n  \n  .justify-evenly {\n    justify-content: space-evenly;\n  }\n\n  .items-center {\n    align-items: center;\n  }\n\n  .pt-0 {\n    padding-top: 0;\n  }\n  \n  .pr-0 {\n    padding-right: 0;\n  }\n  \n  .pb-0 {\n    padding-bottom: 0;\n  }\n  \n  .pl-0 {\n    padding-left: 0;\n  }\n  \n  .pt-1 {\n    padding-top: 1rem;\n  }\n  \n  .pr-1 {\n    padding-right: 1rem;\n  }\n\n  .pr-1-5 {\n    padding-right: 1.5rem;\n  }\n  \n  .pb-1 {\n    padding-bottom: 1rem;\n  }\n  \n  .pl-1 {\n    padding-left: 1rem;\n  }\n\n  .pl-1-5 {\n    padding-left: 1.5rem;\n  }\n  \n  .pt-2 {\n    padding-top: 2rem;\n  }\n  \n  .pr-2 {\n    padding-right: 2rem;\n  }\n  \n  .pb-2 {\n    padding-bottom: 2rem;\n  }\n  \n  .pl-2 {\n    padding-left: 2rem;\n  }\n  \n  .pt-3 {\n    padding-top: 3rem;\n  }\n  \n  .pr-3 {\n    padding-right: 3rem;\n  }\n  \n  .pb-3 {\n    padding-bottom: 3rem;\n  }\n  \n  .pl-3 {\n    padding-left: 3rem;\n  }\n  \n  .pt-4 {\n    padding-top: 4rem;\n  }\n  \n  .pr-4 {\n    padding-right: 4rem;\n  }\n  \n  .pb-4 {\n    padding-bottom: 4rem;\n  }\n  \n  .pl-4 {\n    padding-left: 4rem;\n  }\n  \n  .pt-5 {\n    padding-top: 5rem;\n  }\n  \n  .pr-5 {\n    padding-right: 5rem;\n  }\n  \n  .pb-5 {\n    padding-bottom: 5rem;\n  }\n  \n  .pl-5 {\n    padding-left: 5rem;\n  }\n  \n  .pt-6 {\n    padding-top: 6rem;\n  }\n  \n  .pr-6 {\n    padding-right: 6rem;\n  }\n  \n  .pb-6 {\n    padding-bottom: 6rem;\n  }\n  \n  .pl-6 {\n    padding-left: 6rem;\n  }\n  \n  .pt-7 {\n    padding-top: 7rem;\n  }\n  \n  .pr-7 {\n    padding-right: 7rem;\n  }\n  \n  .pb-7 {\n    padding-bottom: 7rem;\n  }\n  \n  .pl-7 {\n    padding-left: 7rem;\n  }\n  \n  .pt-8 {\n    padding-top: 8rem;\n  }\n  \n  .pr-8 {\n    padding-right: 8rem;\n  }\n  \n  .pb-8 {\n    padding-bottom: 8rem;\n  }\n  \n  .pl-8 {\n    padding-left: 8rem;\n  }\n  \n  .pt-10 {\n    padding-top: 10rem;\n  }\n  \n  .pr-10 {\n    padding-right: 10rem;\n  }\n  \n  .pb-10 {\n    padding-bottom: 10rem;\n  }\n\n  .p-0 {\n    padding: 0;\n  }\n  \n  .p-1 {\n    padding: 1rem;\n  }\n  \n  .p-2 {\n    padding: 2rem;\n  }\n  \n  .p-3 {\n    padding: 3rem;\n  }\n  \n  .p-4 {\n    padding: 4rem;\n  }\n\n  .p-5 {\n    padding: 5rem;\n  }\n\n  .py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .py-0-125 {\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n  }\n  \n  .px-0 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  \n  .py-1 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  \n  .px-1 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  \n  .py-2 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  \n  .px-2 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  \n  .py-3 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n  \n  .px-3 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n  \n  .py-4 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  \n  .px-4 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n  \n  .py-5 {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  }\n  \n  .px-5 {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n  \n  .py-6 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n  \n  .px-6 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n  \n  .py-7 {\n    padding-top: 7rem;\n    padding-bottom: 7rem;\n  }\n  \n  .px-7 {\n    padding-left: 7rem;\n    padding-right: 7rem;\n  }\n  \n  .py-8 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n  \n  .px-8 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n  \n  .py-10 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n  }\n  \n  .px-10 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n  \n  .py-11 {\n    padding-top: 11rem;\n    padding-bottom: 11rem;\n  }\n  \n  .px-11 {\n    padding-left: 11rem;\n    padding-right: 11rem;\n  }\n  \n  .py-12 {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n  \n  .px-12 {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n  \n  .py-13 {\n    padding-top: 13rem;\n    padding-bottom: 13rem;\n  }\n  \n  .px-13 {\n    padding-left: 13rem;\n    padding-right: 13rem;\n  }\n  \n  .py-14 {\n    padding-top: 14rem;\n    padding-bottom: 14rem;\n  }\n  \n  .px-14 {\n    padding-left: 14rem;\n    padding-right: 14rem;\n  }\n  \n  .py-16 {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n  \n  .px-16 {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n  \n  .py-18 {\n    padding-top: 18rem;\n    padding-bottom: 18rem;\n  }\n  \n  .px-18 {\n    padding-left: 18rem;\n    padding-right: 18rem;\n  }\n  \n  .py-19 {\n    padding-top: 19rem;\n    padding-bottom: 19rem;\n  }\n  \n  .px-19 {\n    padding-left: 19rem;\n    padding-right: 19rem;\n  }\n  \n  .py-20 {\n    padding-top: 20rem;\n    padding-bottom: 20rem;\n  }\n  \n  .px-20 {\n    padding-left: 20rem;\n    padding-right: 20rem;\n  }\n  \n  .py-26 {\n    padding-top: 26rem;\n    padding-bottom: 26rem;\n  }\n  \n  .px-26 {\n    padding-left: 26rem;\n    padding-right: 26rem;\n  }\n  \n  .py-34 {\n    padding-top: 34rem;\n    padding-bottom: 34rem;\n  }\n  \n  .px-34 {\n    padding-left: 34rem;\n    padding-right: 34rem;\n  }\n  \n  .py-38 {\n    padding-top: 38rem;\n    padding-bottom: 38rem;\n  }\n  \n  .px-38 {\n    padding-left: 38rem;\n    padding-right: 38rem;\n  }\n  \n  .py-40 {\n    padding-top: 40rem;\n    padding-bottom: 40rem;\n  }\n  \n  .px-40 {\n    padding-left: 40rem;\n    padding-right: 40rem;\n  }\n  \n  .py-48 {\n    padding-top: 48rem;\n    padding-bottom: 48rem;\n  }\n  \n  .px-48 {\n    padding-left: 48rem;\n    padding-right: 48rem;\n  }\n  \n  .py-56 {\n    padding-top: 56rem;\n    padding-bottom: 56rem;\n  }\n  \n  .px-56 {\n    padding-left: 56rem;\n    padding-right: 56rem;\n  }\n  \n  .py-62 {\n    padding-top: 62rem;\n    padding-bottom: 62rem;\n  }\n  \n  .px-62 {\n    padding-left: 62rem;\n    padding-right: 62rem;\n  }\n\n.m-auto{\n    margin: auto;\n}\n\n.my-0 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.my-0-5 {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n\n.mx-0 {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.my-1 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.mx-1 {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.my-2 {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n.mx-2 {\n  margin-left: 2rem;\n  margin-right: 2rem;\n}\n\n.my-3 {\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n\n.mx-3 {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n\n.my-4 {\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n}\n\n.mx-4 {\n  margin-left: 4rem;\n  margin-right: 4rem;\n}\n\n.my-5 {\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n}\n\n.mx-5 {\n  margin-left: 5rem;\n  margin-right: 5rem;\n}\n\n.-mt-0-5 {\n  margin-top: -0.5rem;\n}\n\n.-mr-0-4 {\n  margin-right: -0.4rem;\n}\n\n\n.m-0{\n  margin: 0rem;\n}\n\n.m-0-5 {\n    margin: 0.5rem;\n}\n\n.m-1 {\n    margin: 1rem;\n}\n\n.m-2 {\n    margin: 2rem;\n}\n\n.m-3 {\n    margin: 3rem;\n}\n\n.m-4 {\n    margin: 4rem;\n}\n\n.-mt-0-75 {\n  margin-top: -0.75rem;\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n\n.mt-0-5 {\n  margin-top: 0.5rem;\n}\n\n.mt-0-25 {\n  margin-top: 0.25rem;\n}\n\n.mt-1 {\n    margin-top: 1rem;\n}\n\n.mt-1-5 {\n  margin-top: 1.5rem;\n}\n\n.mt-2 {\n    margin-top: 2rem;\n}\n\n.mt-3 {\n    margin-top: 3rem;\n}\n\n.mt-4 {\n    margin-top: 4rem;\n}\n\n.mt-5 {\n  margin-top: 5rem;\n}\n\n.mt-10 {\n  margin-top: 10rem;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.mb-0-125 {\n  margin-bottom: 0.125rem;\n}\n\n.mb-0-25 {\n  margin-bottom: 0.25rem;\n}\n\n.mb-0-5 {\n  margin-bottom: 0.5rem;\n}\n\n.mb-0-75 {\n  margin-bottom: 0.75rem;\n}\n\n.mb-1-5 {\n  margin-bottom: 1.5rem;\n}\n\n\n.mb-1 {\n    margin-bottom: 1rem;\n}\n\n.mb-2 {\n    margin-bottom: 2rem;\n}\n\n.mb-3 {\n    margin-bottom: 3rem;\n}\n\n.mb-4 {\n    margin-bottom: 4rem;\n}\n\n.mb-5 {\n  margin-bottom: 5rem;\n}\n\n.mb-7 {\n  margin-bottom: 7rem;\n}\n\n\n.mr-0-5 {\n  margin-right: 0.5rem;\n}\n\n.mr-1 {\n    margin-right: 1rem;\n}\n\n.mr-1-5 {\n  margin-right: 1.5rem;\n}\n\n.mr-2 {\n    margin-right: 2rem;\n}\n\n.mr-3 {\n    margin-right: 3rem;\n}\n\n.mr-4 {\n    margin-right: 4rem;\n}\n\n.mr-5 {\n  margin-right: 5rem;\n}\n\n.mr-12 {\n  margin-right: 12rem;\n}\n\n.ml-0-25 {\n  margin-left: 0.25rem;\n}\n\n.ml-0-5 {\n  margin-left: 0.5rem;\n}\n\n.ml-1 {\n    margin-left: 1rem;\n}\n\n.ml-2 {\n    margin-left: 2rem;\n}\n\n.ml-3 {\n    margin-left: 3rem;\n}\n\n.ml-4 {\n    margin-left: 4rem;\n}\n\n.ml-5 {\n  margin-left: 5rem;\n}\n\n.ml-12 {\n  margin-left: 12rem;\n}\n\n.text-bold{\n  font-weight: 700;\n}\n\n.flex{\n    display: flex;\n}\n\n.flex-col{\n    flex-direction: column;\n}\n\n.w-full{\n    width: 100%;\n}\n\n.w-50{\n  width: 50%;\n}\n\n.w-fit-content {\n  width: fit-content;\n}\n\n.max-w-none {\n  max-width: none;\n}\n\n.max-w-2 {\n  max-width: 2rem;\n}\n\n.max-w-5 {\n  max-width: 5rem;\n}\n\n.max-w-8 {\n  max-width: 8rem;\n}\n\n.max-w-10 {\n  max-width: 10rem;\n}\n\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.w-0 {\n  width: 0;\n}\n\n.w-1 {\n  width: 1rem;\n}\n\n.w-2 {\n  width: 2rem;\n}\n\n.w-3 {\n  width: 3rem;\n}\n\n.w-4 {\n  width: 4rem;\n}\n\n.w-5 {\n  width: 5rem;\n}\n\n.w-6 {\n  width: 6rem;\n}\n\n.w-7 {\n  width: 7rem;\n}\n\n.w-8 {\n  width: 8rem;\n}\n\n.w-10 {\n  width: 10rem;\n}\n\n.h-full{\n    height: 100%;\n}\n\n.h-fit-content {\n  height: fit-content;\n}\n\n.h-auo {\n  height: auto;\n}\n\n.h-0 {\n  height: 0;\n}\n\n.h-1 {\n  height: 1rem;\n}\n\n.h-2 {\n  height: 2rem;\n}\n\n.h-3 {\n  height: 3rem;\n}\n\n.h-4 {\n  height: 4rem;\n}\n\n.h-5 {\n  height: 5rem;\n}\n\n.h-6 {\n  height: 6rem;\n}\n\n.h-7 {\n  height: 7rem;\n}\n\n.h-8 {\n  height: 8rem;\n}\n\n.h-10 {\n  height: 10rem;\n}\n\n.cursor-auto {\n  cursor: auto;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-wait {\n  cursor: wait;\n}\n\n.cursor-text {\n  cursor: text;\n}\n\n.color-white{\n  color: #fff;\n}\n\n\n/** Media Queries **/\n\n@media (min-width: 1000px) {\n  .sm\\:px-14 {\n    padding-right: 14rem;\n    padding-left: 14rem;\n  }\n\n  .sm\\:px-18 {\n    padding-right: 18rem;\n    padding-left: 18rem;\n  }\n\n  .sm\\:ml-4{\n    margin-left: 4rem;\n  }\n\n  .sm\\:mt-4{\n    margin-top: 4rem;\n  }\n\n  .sm\\:mb-1{\n    margin-bottom: 1rem;\n  }\n\n  .sm\\:mb-0{\n    margin-bottom: 0rem;\n  }\n\n  .sm\\:mr-0{\n    margin-right: 0rem;\n  }\n\n  .sm\\:ml-0{\n    margin-left: 0rem;\n  }\n\n  .sm\\:hidden {\n    display: none;\n  }\n\n  .sm\\:table-cell {\n    display: table-cell;\n  }\n\n  .sm\\:block {\n    display: block;\n  }\n\n  .sm\\:flex {\n    display: flex;\n  }\n\n  .sm\\:flex-col {\n      flex-direction: column;\n  }\n\n  .sm\\:flex-row {\n    flex-direction: row;\n}\n\n  .sm\\:justify-center {\n    justify-content: center;\n  }\n\n  .sm\\:justify-start {\n    justify-content: start;\n  }\n\n  .sm\\:w-auto {\n    width: auto;\n  }\n\n  .sm\\:w-full {\n    width: 100%;\n  }\n\n\n  .sm\\:ml-1 {\n    margin-left: 1rem;\n  }\n\n  .sm\\:mt-0 {\n    margin-top: 0rem;\n  }\n\n  .sm\\:object-contain{\nobject-fit: contain;\n  }\n\n  .sm\\:ml-12 {\n    margin-left: 12rem;\n  }\n\n  .sm\\:mr-12 {\n    margin-right: 12rem;\n  }\n\n  .sm\\:mr-4 {\n    margin-right: 4rem;\n  }\n\n  .sm\\:w-50 {\n    width: 50%;\n}\n\n.sm\\:h-40{\n  height: 40%;\n}\n\n.sm\\:h-60{\n  height: 60%;\n}\n\n.sm\\:px-6{\n  padding-left: 6rem;\n    padding-right: 6rem;\n}\n\n.sm\\:pt-3{\n  padding-top: 3rem;\n}\n\n.sm\\:ml-2{\n    margin-left: 2rem;\n}\n\n.sm\\:mb-0-5{\n  margin-bottom: 0.5rem;\n}\n\n.sm\\:mb-1-5{\n  margin-bottom: 1.5rem;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
